export class ItemRenew {
  public renewDate: string;
  public itemCd:    string;
  public itemName:  string;
  public standard:  string;
}
